/**
 * Created by Ivan on 19.10.2026
 */

const DiscoPartyTutorial = function () {
    return new TutorialScenario(DiscoPartyTutorial.NAME, {
        manual: true,
        listSteps: DiscoPartyTutorial.listSteps,
        isAvailable: function () {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_DISCO_PARTY);

            return Boolean(mission && mission.logic.isFreeSpinAvailable());
        }
    });
};

DiscoPartyTutorial.listSteps = function () {
    return [DiscoPartyTutorial.createFreeSpinStep()];
};

DiscoPartyTutorial.createFreeSpinStep = function () {
    return new TutorialStep({
        onStart: function () {
            const createForce = () => {
                const window = cleverapps.focusManager.currentWindow();
                const button = ComponentUtils.findChildByName(window, "playButton");

                return cleverapps.forces.create(button, {
                    text: "DiscoParty.Tutorial.freeSpin",
                    pointer: true
                }, {
                    actives: [button],
                    highlights: [window],
                    importantNodes: [button]
                });
            };

            this.force = createForce();

            if (!this.force) {
                this.finish();
                return;
            }

            cleverapps.tutorial.on("onResize", () => {
                this.force.close();
                this.force = createForce();
            }, this);

            cleverapps.tutorial.on("discoPartySpin", this.finish.bind(this), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
            cleverapps.focusManager.setEventNodes([cleverapps.focusManager.currentWindow()]);
        }
    });
};

DiscoPartyTutorial.NAME = "discoparty_tutorial";
